import React from "react";
import styles from "./bundleWrapper.scss";
import {
  getRouter,
  getLoggedInUserInfo,
} from "../../../../common/utils/helper";
import { Icons } from "../assests/icons";
import { useSelector } from "react-redux";
import ProductGallery from "../../../../common/components/productGallery/productGallery";
import FooterWrapper from "../../../../common/components/footerWrapper/footerWrapper";
import { UserRoles } from "../../../../common/constant";
import BreadCrumbs from "../../../../common/components/breadCrumbs/breadCrumbs";
import NoTranslate from "../../../../common/components/notranslate/noTranslate";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
import { useParamas } from '@tw/shared-ui-components/lib/utils/helper';


export default function BundleWrapper(props) {
  const { Link, renderFooter, renderGrandTotal } = props;
  const { params } = useParamas();
  const { COMBINATION_QUANTITIES, COMBINATION_CONSIGNEE_ADA, COMBINATION_MASTER_ITEM_CODE, COMBINATION_MASTER_QUANTITY } = params || {};
  const router = getRouter();
  const breakpoint = useSelector((state) => state?.breakpoint);

  const intlNumberFormatter = new Intl.NumberFormat("en-US");
  const LoggedInUserRole = getLoggedInUserInfo().role;
  const isABO = LoggedInUserRole === UserRoles.ABO;

  const promotionDetails = useSelector(
    (state) => state?.plpState?.promotionDetails
  );

  const defaultItem = useSelector(
    (state) => state?.plpState?.promotionProducts?.defaultItem
  );

  const onCartClick = () => {
    if (!router?.asPath) return;
    const asPath = router?.asPath;
    const conditionalEnumeration = asPath.indexOf("utm_source") !== -1 && asPath.indexOf("utm_medium") !== -1 && asPath.indexOf("utm_campaign") !== -1 && asPath.indexOf("utm_term") !== -1;
    /**
     * 避免影響 UTM 參數在路徑跳轉中丟失
     * */
    if (conditionalEnumeration) {
      if (!asPath.includes("?")) return ''
      if (router) router.push(`/cart?p=${asPath.split('?')[0]}${getQueryUTMString("&")}`);
    } else {
      if (router) router.push(`/cart?p=${asPath.split('?')[0]}`);
    }
  };

  const promotionTitle = useSelector((state) => state?.plpState?.title);
  return (
    <div className={styles["promotion_one_plus_n_container"]}>
      <div className={styles["breadcrumbs-wrapper"]}>
        <BreadCrumbs
          list={[
            { categoryName: "首頁", link: "/" },
            { categoryName: "特惠活動", link: "/promotions/list" },
          ]}
          lastChildName={promotionTitle}
          Link={Link}
        />
      </div>
      {
        COMBINATION_QUANTITIES &&
          COMBINATION_CONSIGNEE_ADA &&
          COMBINATION_MASTER_ITEM_CODE &&
          COMBINATION_MASTER_QUANTITY ?
          <div
            className={styles["top_banner"]}
            onClick={onCartClick}
          >
            <div className={styles["content_area"]}>
              {Icons.backButton}
              <span className={styles["bundle_promotion_text"]}>返回購物車</span>
            </div>
          </div>
          :
          <div
            className={styles["top_banner"]}
            onClick={() => router.push(`/promotions/list${getQueryUTMString("?")}`)}
          >
            <div className={styles["content_area"]}>
              {Icons.backButton}
              <span className={styles["bundle_promotion_text"]}>精選組合</span>
            </div>
          </div>
      }
      <div className={styles["image_and_content"]}>
        <div className={styles["gallery_area"]}>
          {/* <img src={image} /> */}
          <ProductGallery
            gallery={promotionDetails?.gallery}
            showIcons={false}
          />
        </div>

        <div className={styles["product_info"]}>
          <div className={styles["product_name_and_see_detail"]}>
            <div className={styles["product_name"]}>{promotionTitle}</div>

            <a
              href={
                promotionDetails?.detailsPageUrl
                  ? `/page?url=${promotionDetails?.detailsPageUrl}`
                  : ""
              }
              rel="noreferrer"
              target="_blank"
            >
              <a className={styles["see_details"]}>
                {Icons.telescope}
                <span>查看詳情</span>
              </a>
            </a>
          </div>
          {defaultItem && (
            <>
              <div className={styles["price"]}>
                <NoTranslate>
                  $&nbsp;
                  {intlNumberFormatter.format(Number(defaultItem?.price))}
                </NoTranslate>
              </div>
              {isABO && (
                <div className={styles["PV-BV-container"]}>
                  <>
                    <span className={styles["PV-content"]}>PV:</span>
                    <span className={styles["PV-value"]}>
                      {intlNumberFormatter.format(
                        Number(defaultItem?.pointValue)
                      )}
                    </span>
                    <span className={styles["BV-content"]}>BV:</span>
                    <span className={styles["BV-value"]}>
                      {intlNumberFormatter.format(
                        Number(defaultItem?.businessVolume)
                      )}
                    </span>
                  </>
                </div>
              )}
            </>
          )}
          {props.children}
        </div>
      </div>
      <FooterWrapper
        renderTopBar={
          (breakpoint === "sm" || breakpoint === "xs") && renderGrandTotal
        }
      >
        <div className={styles["footer-container"]}>
          <div className={styles["details-div"]}>{renderGrandTotal()}</div>
          <div className={styles["cart-btns"]}>{renderFooter()}</div>
        </div>
      </FooterWrapper>
    </div>
  );
}
